<template>
  <div class="goods-edit-container">
    <!-- 主要内容区域 -->
    <div class="content-area">
      <el-row :gutter="24">
        <!-- 左侧：基本信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-edit"></i>
                编辑商品信息
              </h3>
            </div>
            <el-form ref="item" :model="item" label-width="120px" class="goods-form">
              <!-- 基本信息 -->
              <div class="form-section">
                <h4 class="section-title">基本信息</h4>
                <el-form-item label="商品ID">
                  <el-input 
                    v-model="item.id" 
                    disabled 
                    placeholder="商品ID" 
                    size="medium"
                  />
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="品牌名称" required>
                      <el-input 
                        v-model="item.brand" 
                        placeholder="请输入品牌名称" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品名称" required>
                      <el-input 
                        v-model="item.name" 
                        placeholder="请输入商品名称" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 商品图片 -->
              <div class="form-section">
                <h4 class="section-title">商品图片</h4>
                
                <!-- 未过期状态：1*2布局 -->
                <el-row :gutter="20" v-if="!item.isExpired">
                  <el-col :span="12">
                    <div class="upload-item">
                      <label class="upload-label">到样图</label>
                      <el-upload
                        class="avatar-uploader"
                        action="1111"
                        :show-file-list="false"
                        :before-upload="beforePictureUpload"
                      >
                        <img v-if="item.picture" :src="item.picture" class="avatar">
                        <div v-else class="upload-placeholder">
                          <i class="el-icon-plus"></i>
                          <p>点击上传到样图</p>
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="upload-item">
                      <label class="upload-label">补样图</label>
                      <el-upload
                        class="avatar-uploader"
                        action="1111"
                        :show-file-list="false"
                        :before-upload="beforeSupplePictureUpload"
                      >
                        <img v-if="item.supplePicture" :src="item.supplePicture" class="avatar">
                        <div v-else class="upload-placeholder">
                          <i class="el-icon-plus"></i>
                          <p>点击上传补样图</p>
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                </el-row>
                
                <!-- 过期状态：2*2布局 -->
                <div v-if="item.isExpired">
                  <!-- 第一行：到样图和补样图 -->
                  <el-row :gutter="20" style="margin-bottom: 40px;">
                    <el-col :span="12">
                      <div class="upload-item">
                        <label class="upload-label">到样图</label>
                        <el-upload
                          class="avatar-uploader"
                          action="1111"
                          :show-file-list="false"
                          :before-upload="beforePictureUpload"
                        >
                          <img v-if="item.picture" :src="item.picture" class="avatar">
                          <div v-else class="upload-placeholder">
                            <i class="el-icon-plus"></i>
                            <p>点击上传到样图</p>
                          </div>
                        </el-upload>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="upload-item">
                        <label class="upload-label">补样图</label>
                        <el-upload
                          class="avatar-uploader"
                          action="1111"
                          :show-file-list="false"
                          :before-upload="beforeSupplePictureUpload"
                        >
                          <img v-if="item.supplePicture" :src="item.supplePicture" class="avatar">
                          <div v-else class="upload-placeholder">
                            <i class="el-icon-plus"></i>
                            <p>点击上传补样图</p>
                          </div>
                        </el-upload>
                      </div>
                    </el-col>
                  </el-row>
                  
                  <!-- 第二行：过期商品图片 -->
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="upload-item">
                        <label class="upload-label">过期商品图片</label>
                        <el-upload
                          class="avatar-uploader"
                          action="1111"
                          :show-file-list="false"
                          :before-upload="beforeExpiredPictureUpload"
                        >
                          <img v-if="item.expiredPicture" :src="item.expiredPicture" class="avatar">
                          <div v-else class="upload-placeholder">
                            <i class="el-icon-plus"></i>
                            <p>点击上传过期商品图片</p>
                          </div>
                        </el-upload>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <!-- 预留位置，保持2*2布局的对称性 -->
                    </el-col>
                  </el-row>
                </div>
              </div>
              <!-- 商品属性 -->
              <div class="form-section">
                <h4 class="section-title">商品属性</h4>
                <el-form-item label="商品属性">
                  <el-select 
                    v-model="item.properties" 
                    multiple 
                    filterable 
                    placeholder="请选择商品属性" 
                    size="medium"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="property in properties"
                      :key="property.value"
                      :label="property.label"
                      :value="property.value"
                    />
                  </el-select>
                </el-form-item>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="所属店铺">
                      <el-input 
                        v-model="item.shop" 
                        placeholder="请输入商品所属店铺" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="商品位置">
                      <el-input 
                        v-model="item.location" 
                        placeholder="请输入商品位置" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 价格信息 -->
              <div class="form-section">
                <h4 class="section-title">价格信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="日常价格">
                      <el-input 
                        v-model="item.highPrice" 
                        placeholder="请输入日常价格" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="直播价格">
                      <el-input 
                        v-model="item.lowPrice" 
                        placeholder="请输入直播价格" 
                        clearable
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 时间信息 -->
              <div class="form-section">
                <h4 class="section-title">时间信息</h4>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="到样时间">
                      <el-date-picker 
                        v-model="item.arrivalTime" 
                        type="date" 
                        placeholder="选择到样日期" 
                        style="width: 100%"
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="到期时间">
                      <el-date-picker 
                        v-model="item.exp" 
                        type="date" 
                        placeholder="选择过期日期" 
                        style="width: 100%"
                        size="medium"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <!-- 商品详情 -->
              <div class="form-section">
                <h4 class="section-title">商品详情</h4>
                <el-form-item label="商品描述">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入商品描述" 
                    v-model="item.description" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="到样总数">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入到样总数" 
                    v-model="item.num" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="型号/规格">
                  <el-input 
                    v-model="item.specs" 
                    placeholder="请输入型号/规格信息" 
                    clearable
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="材质/香型">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入材质/香型信息" 
                    v-model="item.material" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="颜色/口味">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入颜色/口味信息" 
                    v-model="item.color" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="赠品">
                  <el-input 
                    type="textarea" 
                    v-model="item.gifts" 
                    placeholder="请输入赠品信息" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
              </div>

              <!-- 试样信息 -->
              <div class="form-section">
                <h4 class="section-title">试样信息</h4>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="通过试样">
                      <el-switch v-model="item.pass" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="18">
                    <el-form-item label="备注">
                      <el-input 
                        type="textarea" 
                        placeholder="请输入试样备注" 
                        v-model="item.tryDetails" 
                        :maxlength="textMaxLenth" 
                        autosize
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
                            <!-- <el-form-item label="排期">
                                <el-col :span="11">
                                  <el-date-picker type="date" placeholder="选择日期" v-model="item.scheduledFrom" style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                  <el-date-picker type="date" placeholder="选择日期" v-model="item.scheduledTo" style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item> -->
              <!-- 已有资源 -->
              <div class="form-section">
                <h4 class="section-title">已有资源</h4>
                <el-form-item label="已拥有资源">
                  <el-checkbox-group v-model="item.has" class="checkbox-group">
                    <el-checkbox label="卖点卡" name="sellingPointCards" />
                    <el-checkbox label="商家卖点卡" name="merchantSellingPointCards" />
                    <el-checkbox label="比价图" name="PriceComparisonChart" />
                    <el-checkbox label="辅助文件" name="auxiliaryFiles" />
                  </el-checkbox-group>
                </el-form-item>
              </div>

              <!-- 附件上传 -->
              <div class="form-section">
                <h4 class="section-title">附件上传</h4>
                <el-form-item label="附件列表">
                  <el-upload
                    class="upload-demo"
                    action="http://47.108.21.146:7777/goods"
                    :before-upload="handleBeforeUpload"
                    :on-remove="handleRemove"
                    :on-preview="handlePreview"
                    :before-remove="beforeRemove"
                    :file-list="item.fileList"
                  >
                    <el-button size="medium" type="primary" icon="el-icon-upload">
                      点击上传附件
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持上传各种格式的文件，单个文件不超过10MB
                    </div>
                  </el-upload>
                </el-form-item>
              </div>
              <!-- 操作按钮 -->
              <div class="form-actions">
                <el-button type="primary" size="large" @click="update" icon="el-icon-check">
                  保存修改
                </el-button>
                <el-button size="large" @click="beforeMove" type="danger" icon="el-icon-delete">
                  删除商品
                </el-button>
              </div>
            </el-form>
          </el-card>
        </el-col>

        <!-- 右侧：补样和退样信息 -->
        <el-col :span="12">
          <el-card class="form-card" shadow="always">
            <div class="card-header">
              <h3 class="card-title">
                <i class="el-icon-refresh"></i>
                补样和退样信息
              </h3>
            </div>
            <el-form ref="suppleForm" :model="item" label-width="100px" class="supple-form">
              <!-- 补样信息 -->
              <div class="form-section">
                <h4 class="section-title">补样信息</h4>
                <el-form-item label="补样时间">
                  <el-date-picker 
                    v-model="item.suppleTime" 
                    type="date" 
                    placeholder="选择补样日期" 
                    style="width: 100%"
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="补样数量">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入补样数量" 
                    v-model="item.suppleNum" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入补样备注" 
                    v-model="item.suppleDetails" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
              </div>

              <!-- 退样信息 -->
              <div class="form-section">
                <h4 class="section-title">退样信息</h4>
                <el-form-item label="退样时间">
                  <el-date-picker 
                    v-model="item.returnTime" 
                    type="date" 
                    placeholder="选择退样日期" 
                    style="width: 100%"
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样地址">
                  <el-input 
                    v-model="item.returnAddress" 
                    placeholder="请输入退样地址" 
                    clearable
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="退样单号">
                  <el-input 
                    v-model="item.returnNumber" 
                    placeholder="请输入退样单号" 
                    clearable
                    size="medium"
                  />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input 
                    type="textarea" 
                    placeholder="请输入退样备注" 
                    v-model="item.returnDetails" 
                    :maxlength="textMaxLenth" 
                    autosize
                  />
                </el-form-item>
                <el-form-item label="退样图片">
                  <el-upload
                    class="upload-demo"
                    action="http://47.108.21.146:7777/goods"
                    :on-remove="handleReturnRemove"
                    :on-preview="handlePreview"
                    :before-remove="beforeReturnRemove"
                    :before-upload="handleReturnBeforeUpload"
                    :file-list="item.returnFileList"
                  >
                    <el-button size="medium" type="primary" icon="el-icon-upload">
                      点击上传退样图片
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      支持上传图片格式，单个文件不超过10MB
                    </div>
                  </el-upload>
                </el-form-item>
              </div>

              <!-- 盘货管理 -->
              <div class="form-section">
                <h4 class="section-title">盘货管理</h4>
                <el-form-item label="盘货操作">
                  <el-row :gutter="10">
                    <el-col :span="7">
                      <el-select 
                        v-model="selectInventoryTime" 
                        size="medium" 
                        placeholder="选择盘货日期"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="inventory in inventoryTime" 
                          :key="inventory.id"  
                          :label="inventory.time" 
                          :value="inventory.id"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="11">
                      <el-input 
                        type="textarea" 
                        placeholder="请输入盘货备注" 
                        v-model="selectInventoryTimeDetails" 
                        :maxlength="textMaxLenth"
                        autosize
                      />
                    </el-col>
                    <el-col :span="6">
                      <el-button 
                        size="medium" 
                        type="primary" 
                        @click="handlBeforeAddToInventory()"
                        style="width: 100%; white-space: nowrap;"
                      >
                        加入盘货
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                
                <el-form-item label="盘货历史" v-if="inventoryHis && inventoryHis.length > 0">
                  <el-table :data="inventoryHis" stripe style="width: 100%" max-height="300px">
                    <el-table-column prop="time" label="时间" width="200px" />
                    <el-table-column prop="details" label="备注" />
                  </el-table>
                </el-form-item>
              </div>

              <!-- 商品状态 -->
              <div class="form-section">
                <h4 class="section-title">商品状态</h4>
                <el-alert
                  v-if="item.isExpired"
                  title="商品已过期，可以上传过期商品图片"
                  type="warning"
                  :closable="false"
                  style="margin-bottom: 20px;"
                />
                <el-row :gutter="20">
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否退样</label>
                      <el-switch v-model="item.isReturned" />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否过期</label>
                      <el-switch v-model="item.isExpired" @change="handleExpiredChange" />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否补样</label>
                      <el-switch v-model="item.isSupply" />
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="status-item">
                      <label>是否报损</label>
                      <el-switch v-model="item.isReportLosses" />
                    </div>
                  </el-col>
                </el-row>
              </div>

              <!-- 直播记录 -->
              <div class="form-section" v-if="item.history && item.history.length > 0">
                <h4 class="section-title">直播记录</h4>
                <el-table
                  :data="item.history"
                  stripe
                  style="width: 100%"
                  max-height="300px"
                >
                  <el-table-column prop="date" label="历史直播记录" />
                </el-table>
              </div>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Common from '@/components/Common'
import { goodsApi, inventoryApi, userApi } from '@/api'
export default {
  name: 'GoodsEdit',
  data () {
    return {
      item: {
        id: this.$route.query.id,
        brand: '',
        name: '',
        properties: [],
        shop: '',
        picture: '',
        supplePicture: '',
        expiredPicture: '',
        location: '',
        highPrice: '',
        lowPrice: '',
        exp: '',
        gifts: '',
        description: '',
        arrivalTime: '',
        num: '',
        specs: '',
        material: '',
        color: '',
        tryDetails: '',
        pass: false,
        scheduledFrom: '',
        scheduledTo: '',
        has: [],
        suppleTime: '',
        suppleNum: '',
        suppleDetails: '',
        returnFileList: [],
        returnTime: '',
        returnAddress: '',
        returnNumber: '',
        returnDetails: '',
        fileList: [],
        history: [],
        isReturned: false,
        isExpired: false,
        isSupply: false,
        isReportLosses: false
      },
      properties: [],
      selectInventoryTime: this.$route.query.timeId,
      inventoryTime: [],
      selectInventoryTimeDetails: '',
      inventoryHis: [],
      textMaxLenth: 300
    }
  },
  created () {
    this.getProperty()
    this.getItemById()
    this.getAllInventory()
    this.getInventoryHis()
  },
  methods: {
    async getAllInventory () {
      try {
        const response = await inventoryApi.getAllInventory()
        this.inventoryTime = []
        for (var i in response) {
          let s = response[i].time
          let time = s.substring(0, s.indexOf(' '))
          let live = {id: response[i].id, time: time}
          this.inventoryTime.push(live)
        }
      } catch (error) {
        console.error('获取盘货时间失败:', error)
        this.$message.error('获取盘货时间失败')
      }
    },
    async getProperty () {
      try {
        const response = await goodsApi.getProperty()
        this.properties = response
      } catch (error) {
        console.error('获取属性失败:', error)
        this.$message.error('获取属性失败')
      }
    },
    async getItemById () {
      try {
        const response = await goodsApi.getById(this.$route.query.id)
        this.item = response
        if (this.item.pass === 'true') {
          this.item.pass = true
        } else {
          this.item.pass = false
        }
        if (this.item.isExpired === 'true') {
          this.item.isExpired = true
        } else {
          this.item.isExpired = false
        }
        if (this.item.isReturned === 'true') {
          this.item.isReturned = true
        } else {
          this.item.isReturned = false
        }
        if (this.item.isSupply === 'true') {
          this.item.isSupply = true
        } else {
          this.item.isSupply = false
        }
        if (this.item.isReportLosses === 'true') {
          this.item.isReportLosses = true
        } else {
          this.item.isReportLosses = false
        }
        console.log(this.item)
        let propertyNameList = response.properties.split(' · ')
        response.properties = []
        for (let i in propertyNameList) {
          let name = propertyNameList[i]
          for (let j in this.properties) {
            if (this.properties[j].label === name) response.properties.push(this.properties[j].value)
          }
        }
        this.item.properties = response.properties
      } catch (error) {
        console.error('获取商品详情失败:', error)
        this.$message.error('获取商品详情失败')
      }
    },
    async update () {
      let data = this.item
      console.log(this.item)
      console.log(this.item.isExpired)
      if ((this.item.isExpired === true && this.item.isReturned === true)) {
        this.$message.warning('请检查商品详情栏')
        return
      }

      // 数据一致性检查：如果商品未过期，清空过期图片字段
      if (!this.item.isExpired && this.item.expiredPicture) {
        console.log('检测到非过期商品有过期图片，自动清空')
        this.item.expiredPicture = ''
        data.expiredPicture = ''
      }

      try {
        await goodsApi.updateGoods(data)
        this.$message.success('保存商品成功！')
      } catch (error) {
        console.error('保存商品失败:', error)
        this.$message.error('保存商品失败')
      }
    },
    move () {
      Object.assign(this.$data, this.$options.data())
    },
    handleRemove (file) {
      for (var i = 0; i < this.item.fileList.length; i++) {
        if (this.item.fileList[i].uid === file.uid) {
          this.item.fileList.splice(i, 1)
          i--
        }
      }
    },
    handleBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      console.log('开始上传，上传的文件为：' + file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          let addFile = {
            'name': file.name,
            'url': res.data.data
          }
          console.log(res.data.data)
          this.item.fileList.push(addFile)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    handleReturnRemove (file) {
      for (var i = 0; i < this.item.returnFileList.length; i++) {
        if (this.item.returnFileList[i].uid === file.uid) {
          this.item.returnFileList.splice(i, 1)
          i--
        }
      }
    },
    handleReturnBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      console.log('开始上传，上传的文件为：' + file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          let addFile = {
            'name': file.name,
            'url': res.data.data
          }
          this.item.returnFileList.push(addFile)
          console.log(this.item.returnFileList)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handlePreview (file) {
      window.open(file.url)
    },
    beforeReturnRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    async beforePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        this.item.picture = response
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败')
      }
    },
    async beforeSupplePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('文件上传成功！')
        this.item.supplePicture = response
        this.$forceUpdate()
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败')
      }
    },
    vaildPicture (file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        return
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      return isJPG && isLt10M
    },
    async beforeExpiredPictureUpload (file) {
      if (!this.vaildPicture(file)) return
      try {
        const response = await goodsApi.uploadFile(file)
        this.$message.success('过期商品图片上传成功！')
        this.item.expiredPicture = response
        this.$forceUpdate()
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败')
      }
    },
    handleExpiredChange (value) {
      console.log('过期状态变更:', value, '当前过期图片:', this.item.expiredPicture)
      // 当过期状态从true变为false时，清空过期图片字段
      if (!value && this.item.expiredPicture) {
        this.item.expiredPicture = ''
        this.$message.info('商品状态已改为非过期，过期图片已清空')
        console.log('已清空过期图片字段')
      }
    },
    beforeMove () {
      this.$confirm('是否删除' + this.item.name, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteItem () {
      this.$axios.get(Common.baseUrl + 'goods/deleteById', {params: {id: this.item.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '删除商品成功！',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    handlBeforeAddToInventory () {
      console.log(this.selectInventoryTime)
      let timeId = this.selectInventoryTime
      if (timeId === '' || timeId === undefined) {
        this.$message({
          message: '请选择盘货日期！',
          type: 'warning'
        })
        return
      }
      let selectTime = ''
      for (var i in this.inventoryTime) {
        if (this.inventoryTime[i].id === timeId) {
          selectTime = this.inventoryTime[i].time
        }
      }
      this.$confirm('是否加入盘货日期  ' + selectTime + '  ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleAddToInventory()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async handleAddToInventory () {
      this.update()
      let data = { goodsId: this.item.id, inventoryTimeId: this.selectInventoryTime, details: this.selectInventoryTimeDetails }

      try {
        await inventoryApi.addToInventory(data)
        this.$message.success('盘货成功！')
        this.getInventoryHis()
      } catch (error) {
        console.error('盘货失败:', error)
        this.$message.error('盘货失败')
      }
    },
    async getInventoryHis () {
      try {
        const response = await inventoryApi.getInventoryHistory(this.item.id)
        this.inventoryHis = response
      } catch (error) {
        console.error('获取盘货历史失败:', error)
        this.$message.error('获取盘货历史失败')
      }
    }
  }
}
</script>
<style scoped>
/* 主容器 */
.goods-edit-container {
  padding: 40px;
  background-color: #ffffff;
  min-height: 100vh;
}

/* 内容区域 */
.content-area {
  max-width: 1600px;
  margin: 0 auto;
}

/* 表单卡片 */
.form-card {
  border-radius: 16px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.card-header {
  padding: 30px 0;
  border-bottom: 2px solid #EBEEF5;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px 16px 0 0;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 表单样式 */
.goods-form, .supple-form {
  padding: 0 40px 40px;
}

.form-section {
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  border-left: 6px solid #409EFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.form-section:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title::before {
  content: '';
  width: 6px;
  height: 20px;
  background: linear-gradient(135deg, #409EFF 0%, #66B1FF 100%);
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
}

/* 上传组件 */
.upload-item {
  text-align: center;
}

.upload-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  font-weight: 500;
}

.avatar-uploader .el-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  height: 150px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
  background-color: #f0f9ff;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #8c939d;
}

.upload-placeholder i {
  font-size: 32px;
  margin-bottom: 8px;
}

.upload-placeholder p {
  font-size: 12px;
  margin: 0;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 操作按钮 */
.form-actions {
  text-align: center;
  padding: 40px 0;
  border-top: 2px solid #EBEEF5;
  margin-top: 30px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 0 0 16px 16px;
}

.form-actions .el-button {
  margin: 0 15px;
  min-width: 150px;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.form-actions .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-area .el-col {
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .goods-edit-container {
    padding: 10px;
  }
  
  .form-section {
    padding: 15px;
  }
  
  .form-actions .el-button {
    width: 100%;
    margin: 5px 0;
  }
}

/* 复选框组 */
.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-group .el-checkbox {
  margin-right: 0;
}

/* 状态项 */
.status-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 15px;
  background-color: #FAFAFA;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
}

.status-item label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

/* Element UI 组件样式优化 */
.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.el-input__inner, .el-textarea__inner {
  border-radius: 6px;
}

.el-button {
  border-radius: 6px;
}

.el-card {
  border-radius: 12px;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/GoodsEdit.vue